import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '../../../../pipes/translate.pipe';
import { PrimeNGModules } from '../../../../shared/alpha-shared.module';

@Component({
    selector: 'app-filter-number-range',
    standalone: true,
    templateUrl: './filter-number-range.component.html',
    styleUrl: './filter-number-range.component.scss',
    imports: [...PrimeNGModules, ReactiveFormsModule, TranslatePipe],
})
export class FilterNumberRangeComponent {
    @Input() formGroup!: FormGroup;
    @Input() controlName: any;
}
